import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Loader2, Send } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const DriverRequestModal = ({ driver, onOpenChange }) => {
  const [form, setForm] = useState({ requester_name: "", requester_email: "", requester_phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/drivers/${driver.id}/requests`, form);
      toast.success("Request sent! RelayRigs will help coordinate this assignment.");
      onOpenChange(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't send your request. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={!!driver} onOpenChange={onOpenChange}>
      <DialogContent data-testid="driver-request-modal" className="max-w-sm rounded-2xl">
        <DialogHeader>
          <DialogTitle data-testid="driver-request-title" className="font-heading text-xl text-rr-navy">Request {driver?.name}</DialogTitle>
          <DialogDescription>We'll pass your request along and help coordinate the assignment — your contact info stays private.</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} data-testid="driver-request-form" className="space-y-3">
          <input required data-testid="driver-request-name-input" placeholder="Your name" value={form.requester_name} onChange={update("requester_name")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
          <input required type="email" data-testid="driver-request-email-input" placeholder="Your email" value={form.requester_email} onChange={update("requester_email")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
          <input type="tel" data-testid="driver-request-phone-input" placeholder="Phone (optional)" value={form.requester_phone} onChange={update("requester_phone")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
          <textarea data-testid="driver-request-message-input" placeholder="What do you need? (route, dates, equipment...)" value={form.message} onChange={update("message")} rows={3} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange resize-none" />
          <button type="submit" disabled={submitting} data-testid="driver-request-submit-button" className="w-full bg-rr-navy text-white font-bold py-3.5 rounded-full hover:bg-rr-orange transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {submitting ? <Loader2 size={18} className="animate-spin" /> : <>Send Request <Send size={15} /></>}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
